import request from "@/common/request.js";

export function listPartner(data) {
  return request({
    url: "/system/partners/list",
    method: "post",
    params: data,
  });
}
